import React from 'react';
import VerifiedFlame from './VerifiedFlame';
import { measurableInputProps } from '../lib/measurableInput';

export default function MeasurableField({ measurable, value, verified, onValueChange, onCommit }) {
  const m = measurable;
  const props = measurableInputProps(m);
  const labelText = m.unit ? `${m.label} (${m.unit})` : m.label;

  return (
    <div className="form-field">
      <label className="form-field__label" htmlFor={m.key}>
        {labelText}
        {verified && <VerifiedFlame />}
      </label>
      {props.kind === 'enum' ? (
        <select
          id={m.key}
          name={m.key}
          className="form-field__input"
          value={value || ''}
          onChange={(e) => { onValueChange(m.key, e.target.value); onCommit(m.key, e.target.value); }}
        >
          <option value="">Select...</option>
          {props.options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      ) : (
        <input
          id={m.key}
          name={m.key}
          type="number"
          className="form-field__input"
          value={value ?? ''}
          step={props.step}
          min={props.min}
          max={props.max}
          onChange={(e) => onValueChange(m.key, e.target.value)}
          onBlur={(e) => onCommit(m.key, e.target.value)}
        />
      )}
    </div>
  );
}
